import { FC, ReactNode } from 'react'
import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { Card } from 'react-native-paper'

interface OrderCardProps {
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

const OrderCard: FC<OrderCardProps> = ({ children, style }) => {
    return (
        <Card elevation={3} style={[styles.container, style]}>
            {children}
        </Card>
    )
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#FFFFFF',
        borderRadius: 4,
        overflow: 'hidden',
    },
})

export default OrderCard
